import { navigate } from "gatsby";

export function goto(where) {
  if (typeof window !== "undefined") {
    navigate(where);
  }
}
